import { routes, sidebarContent, sidebarFooter } from '@/lib/constants';
import { Separator, SidebarLink } from '@/components/atoms';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  usePlanGate,
} from '@/components/organisms';
import SellytLogo from '@/assets/svg/sellyt-logo.svg?react';
import { Link } from 'react-router';

export const AppSidebar = () => {
  const { allowsFeature } = usePlanGate();

  const onBeforeNavigate = (pathname: string) => {
    if (pathname === routes.analytics) return allowsFeature('analytics');
    return true;
  };

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader className="px-4 pt-4">
        <Link to={routes.root}>
          <SellytLogo className="w-20" />
        </Link>
      </SidebarHeader>
      <SidebarContent className="p-4 flex flex-col gap-2.5">
        {sidebarContent.map((link, index) => (
          <SidebarLink
            key={index}
            {...link}
            onBeforeNavigate={onBeforeNavigate}
          />
        ))}
      </SidebarContent>
      <Separator />
      <SidebarFooter>
        {sidebarFooter.map((link, index) => (
          <SidebarLink
            key={index}
            {...link}
            onBeforeNavigate={onBeforeNavigate}
          />
        ))}
      </SidebarFooter>
    </Sidebar>
  );
};
